import React from 'react';
import {isEmpty} from 'ramda';

import flags, {isHtoEnabled} from 'constants/flags/flags';
import {DISTANCE_AND_READING_DESCRIPTION} from 'features/wizardMs/constants/usages';
import {UsageItemType} from 'features/wizardMs/reducers/usages/usages';
import {DiscountBadge} from './multifocalPrice';
import s from './firstStepPriceInfo.scss';

export const DISCOUNT_PRICE = 75;

/**
 * Helper func, which return expProgressFunnelM is enable or not
 * base on hto value
 * @returns {boolean} boolean value
 */
export const checkProgrExpEnabled = () => {
    if (isHtoEnabled()) {
        return false;
    }

    if (flags.expProgressFunnelM.getValue() === 'A') {
        return false;
    }

    return flags.expProgressFunnelM.getValue();
};

/**
 * Return is initial price for exp enabled or not
 * @param {UsageItemType} selectedUsage current usage
 * @returns {boolean} value
 */
export const getInitialPriceEnabled = (selectedUsage: UsageItemType | {}) =>
    isEmpty(selectedUsage) ||
    (selectedUsage as UsageItemType)?.title !== DISTANCE_AND_READING_DESCRIPTION.title;

/**
 * Render initial price for wizard first step
 * @param {{progressivePrice:number}} props component
 * @constructor
 */
export const InitialPrice = ({progressivePrice}) => (
    <>
        <p className={s.oldPrice}>${progressivePrice}</p>
        <p className={s.newPrice}>+${progressivePrice - DISCOUNT_PRICE}</p>
        <DiscountBadge />
    </>
);

/**
 * Return promo text for first step depends on experiment flag
 * @param {number} progressivePrice component
 * @returns {React.Node} return component
 */
export const getPackagePrice = (progressivePrice: number) =>
    flags.expProgressFunnelM.getValue() === 'B' ? (
        <InitialPrice progressivePrice={progressivePrice} />
    ) : (
        <>Starts from as low as $19</>
    );
